import { createSelector } from 'reselect';
import { getConfigData } from 'src/modules/config/selectors/getConfigData';

export const getLocale = createSelector([
  getConfigData,
], (config) => config.i18n.locale);
